<div class="modal fade" id="row-details-dialog" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="row-details-title"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                </button>
            </div>

            <div class="modal-body">

                <!-- Scores -->
                <table class="table table-bordered table-striped align-middle">
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Score</th>
                        </tr>
                    </thead>

                    <tbody>
                    </tbody>
                </table>

                <hr>

                <!-- Submit score -->
                <h6 class="mb-3">Change your score</h6>

                <div class="mb-3 d-flex flex-column gap-2 align-items-end">
                    <input type="number" class="form-control" id="row-score-input" placeholder="Enter score">
                    <div class="form-check  ">
                        <input type="checkbox" class="form-check-input" id="check-joker">
                        <label for="check-joker" class="form-check-label">Joker</label>
                    </div>
                </div>

                <hr>

                <!-- General -->
                <h6 class="mb-3">Change row name</h6>

                <div class="mb-4 d-flex flex-column gap-2 align-items-end">
                    <input type="text" class="form-control" id="row-name-input" placeholder="Enter row name">
                </div>

                <hr>

                <!-- Entry image -->
                <h6 class="mb-3">Change image</h6>

                <div class="d-flex flex-column gap-2 w-100">
                    <div class="d-flex flex-row gap-2 w-100">
                        <input type="file" id="input-image-upload" class="form-control flex-grow-1" accept="image/png,image/jpeg">
                        <button id="btn-image-paste" class="btn btn-primary text-nowrap">
                            <i class="bi bi-clipboard"></i>
                        </button>
                    </div>
                    <span id="image-err-msg" class="d-none"></span>
                    <div id="image-preview-div" class="d-flex flex-row justify-content-center align-items-center gap-2 d-none">
                        <img id="image-preview" style="max-height: 100px; object-fit: contain;">
                        <button id="btn-remove-image" class="btn btn-outline-danger"><i class="bi bi-trash"></i></button>
                    </div>
                </div>
            </div>

            <div class="modal-footer d-flex w-100 justify-content-between">
                <button type="button" class="btn btn-danger" id="btn-delete-row">
                    Delete Row
                </button>

                <button type="button" class="btn btn-primary" id="row-details-submit">
                    Submit
                </button>
            </div>

        </div>
    </div>
</div>